import { mergeStyles } from '../../../../../internal/utils/mergeStyles';
import * as mainStyles from './styles.css';
export var getStyles = function getStyles(size) {
  return mergeStyles(mainStyles, require("./size/".concat(size, ".css")));
};